jQuery(document).ready(function ($) {
  // Variables for the first set of dropdown and labels
  var dropdownField1 = $('#input_2_23');
  var labelField1_1 = $('fieldset#field_2_24>legend.gfield_label.gform-field-label');
  var labelField1_2 = $('fieldset#field_2_31>legend.gfield_label');

  // Variables for the second set of dropdown and labels
  var dropdownField2 = $('#input_4_23');
  var labelField2_1 = $('fieldset#field_4_24>legend.gfield_label.gform-field-label');
  var labelField2_2 = $('fieldset#field_4_31>legend.gfield_label');

  // Function to update labels for the first set
  function updateLabels1() {
    var selectedOption = dropdownField1.find('option:selected').text();

    // Update label 1
    labelField1_1.text("How would you rate your overall satisfaction with " + selectedOption + '?');

    // Update label 2
    labelField1_2.text("On a scale of 0 (very unlikely) to 10 (very likely), how likely are you to recommend " + selectedOption + " to a friend or colleague?");
  }

  // Function to update labels for the second set
  function updateLabels2() {
    var selectedOption = dropdownField2.find('option:selected').text();

    // Update label 1
    labelField2_1.text("How would you rate your overall satisfaction with " + selectedOption);

    // Update label 2
    labelField2_2.text("On a scale of 0 (very unlikely) to 10 (very likely), how likely are you to recommend " + selectedOption + " to a friend or colleague?");
  }

  // Call updateLabels for both sets on page load
  updateLabels1();
  updateLabels2();

  // Update labels for the first set when the dropdown value changes
  dropdownField1.change(function () {
    updateLabels1();
  });

  // Update labels for the second set when the dropdown value changes
  dropdownField2.change(function () {
    updateLabels2();
  });
  // Handle the survey form logic
  $('[data-open-survey-form]').click(function (e) {
    e.preventDefault(); // Prevent default action to ensure accessibility

    let surveyScriptID = $(this).attr('data-open-survey-form');

    if ($('#survey-form').length) {
      $('#survey-form > div > .wp-block-group').each(function () {
        $(this).addClass('hide').attr('aria-hidden', 'true'); // Add aria-hidden
      });

      let $targetForm = $('#survey-form').find('#' + surveyScriptID);
      $targetForm.removeClass('hide').attr('aria-hidden', 'false'); // Remove aria-hidden
      $targetForm.focus(); // Move focus to the revealed section

      $('html, body').animate({
        scrollTop: $('#survey-form').offset().top - ($('header.header').outerHeight() || 0)
      }, 500);
    }
  });

  // Ensure that hidden elements cannot be focused
  $('.wp-block-group').each(function () {
    if ($(this).hasClass('hide')) {
      $(this).attr('aria-hidden', 'true');
    } else {
      $(this).attr('aria-hidden', 'false');
    }
  });


});
document.addEventListener('DOMContentLoaded', function () {
  const radioStarsGroups = document.querySelectorAll('.radio-stars');

  radioStarsGroups.forEach(group => {
      const radioButtons = group.querySelectorAll('.gfield-choice-input');
      const labels = group.querySelectorAll('.gform-field-label');

      function updateStars(selectedIndex) {
          labels.forEach((label, index) => {
              if (index <= selectedIndex) {
                  label.classList.add('star-checked');
              } else {
                  label.classList.remove('star-checked');
              }
          });
      }

      radioButtons.forEach((radio, index) => {
          radio.addEventListener('change', function () {
              updateStars(index);
          });
      });
  });
});